import { CategoryCard } from '#/components/ui/CategoryCard';
import { SectionHeader } from '#/components/ui/SectionHeader';
import type { RelatedCategoryTopic } from '#/lib/category-navigation';
import { cn } from '#/utils/cn';

interface CategoryRelatedSectionProps {
  topics: RelatedCategoryTopic[];
  /** GTM `data-track` id forwarded onto each related-topic card anchor. */
  topicTrack?: string;
  /** GTM `data-track-context` forwarded onto each related-topic card anchor. */
  topicTrackContext?: string;
}

/**
 * The Related Topics section for categories Uses the static product/sector
 * definitions and super-sector groups to determine what to display
 */
export function CategoryRelatedSection({
  topics,
  topicTrack,
  topicTrackContext,
}: CategoryRelatedSectionProps) {
  if (topics.length === 0) {
    return null;
  }

  return (
    <section
      id="related"
      className="flow flow-inner-20 scroll-mt-(--scroll-offset)"
    >
      <SectionHeader title="Related Topics" actionAlignment="center" />

      <div
        className={cn(
          'grid gap-12',
          topics.length === 2 && 'md:grid-cols-2',
          topics.length >= 3 && 'md:grid-cols-3',
        )}
      >
        {topics.map((topic) => (
          <CategoryCard
            key={topic.slug}
            eyebrow={topic.eyebrow}
            title={topic.title}
            description={topic.description}
            to={topic.href}
            dataTrack={topicTrack}
            dataTrackLabel={topicTrack ? topic.title : undefined}
            dataTrackContext={topicTrackContext}
          />
        ))}
      </div>
    </section>
  );
}
